import type { CSSProperties, ReactNode } from "react";

interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export default function Reveal({ children, className = "", delay = 0 }: RevealProps) {
  const style: CSSProperties = delay ? { transitionDelay: `${delay}ms` } : {};
  return (
    <div className={`reveal ${className}`} style={style}>
      {children}
    </div>
  );
}